import {
  getWorkspacePathType,
  type WorkspacePathType,
} from '@/lib/workspace/routerHelpers'

const CHUNK_LOAD_RECOVERY_KEY = 'chunk_load_recovery'
export const CHUNK_LOAD_RETRY_KEY = 'chunk_reload_attempts'

const WORKSPACE_PATH_TYPES = new Set<WorkspacePathType>([
  'portfolio-home',
  'portfolio-workspace',
  'product-workspace',
  'other',
])

export interface ChunkLoadRecovery {
  attempt: number
  route: WorkspacePathType
}

export const saveChunkLoadRecovery = (attempt: number): void => {
  try {
    sessionStorage.setItem(
      CHUNK_LOAD_RECOVERY_KEY,
      JSON.stringify({
        attempt,
        route: getWorkspacePathType(window.location.pathname),
      })
    )
  } catch {}
}

export const resetChunkLoadRetryAttempts = (): void => {
  try {
    sessionStorage.removeItem(CHUNK_LOAD_RETRY_KEY)
  } catch {}
}

export const consumeChunkLoadRecovery = (): ChunkLoadRecovery | null => {
  try {
    const storedRecovery = sessionStorage.getItem(CHUNK_LOAD_RECOVERY_KEY)
    sessionStorage.removeItem(CHUNK_LOAD_RECOVERY_KEY)

    if (!storedRecovery) {
      return null
    }

    const recovery = JSON.parse(storedRecovery) as Partial<ChunkLoadRecovery>

    if (
      typeof recovery.attempt !== 'number' ||
      !Number.isSafeInteger(recovery.attempt) ||
      recovery.attempt <= 0 ||
      !WORKSPACE_PATH_TYPES.has(recovery.route ?? 'other')
    ) {
      return null
    }

    return recovery as ChunkLoadRecovery
  } catch {
    return null
  }
}
